module.exports = __webpack_public_path__ + "img/login-mall.77aedf49.svg";